import SvgIcon from '@mui/material/SvgIcon';

const RelayLogs = (props) => {
    return (
        <SvgIcon {...props}>
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_6689_146465)">
                    <path
                        d="M19.8564 14.3259C20.9083 14.3199 21.8197 14.8914 22.3076 15.7419L35.4716 15.6667C36.2572 15.6623 36.8882 16.2978 36.8837 17.0886C36.8792 17.8792 36.2406 18.5216 35.455 18.5261L22.291 18.6003C21.7979 19.4563 20.8761 20.0386 19.8242 20.0446C18.2574 20.0535 16.9911 18.7779 16.9999 17.2009C17.009 15.624 18.2897 14.3348 19.8564 14.3259ZM19.8339 16.1159C19.5688 16.1159 19.3144 16.2215 19.1269 16.4089C18.9394 16.5964 18.834 16.8507 18.8339 17.1159C18.8339 17.3811 18.9394 17.6354 19.1269 17.8229C19.3144 18.0104 19.5688 18.1159 19.8339 18.1159C20.099 18.1158 20.3535 18.0104 20.541 17.8229C20.7283 17.6354 20.8339 17.381 20.8339 17.1159C20.8339 16.8508 20.7284 16.5964 20.541 16.4089C20.3535 16.2214 20.099 16.116 19.8339 16.1159Z"
                        fill="white"
                    />
                    <path
                        d="M6.02741 14.3259C4.97553 14.3199 4.06409 14.8914 3.57624 15.7419L-9.58782 15.6667C-10.3734 15.6623 -11.0044 16.2978 -10.9999 17.0886C-10.9954 17.8792 -10.3568 18.5216 -9.57122 18.5261L3.59284 18.6003C4.08587 19.4563 5.00776 20.0386 6.05964 20.0446C7.62641 20.0535 8.89275 18.7779 8.88386 17.2009C8.87479 15.624 7.59407 14.3348 6.02741 14.3259ZM6.04988 16.1159C6.31498 16.1159 6.56939 16.2215 6.75691 16.4089C6.94441 16.5964 7.04984 16.8507 7.04988 17.1159C7.04988 17.3811 6.94444 17.6354 6.75691 17.8229C6.56938 18.0104 6.31504 18.1159 6.04988 18.1159C5.78479 18.1158 5.5303 18.0104 5.34284 17.8229C5.15546 17.6354 5.04988 17.381 5.04988 17.1159C5.04991 16.8508 5.15541 16.5964 5.34284 16.4089C5.5303 16.2214 5.78479 16.116 6.04988 16.1159Z"
                        fill="white"
                    />
                    <path
                        d="M15.3502 6.18431L6.84686 14.5917L8.69364 16.4178L17.197 8.01039C17.7044 7.50867 17.7017 6.69531 17.191 6.19028C16.6802 5.68526 15.8576 5.68259 15.3502 6.18431Z"
                        fill="white"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_6689_146465">
                        <rect width="25" height="25" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </SvgIcon>
    );
};

export default RelayLogs;
